import { RestaurantOrderInformations } from "./RestaurantOrderInformations";

export default RestaurantOrderInformations;
